"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var Tab = function Tab(_ref) {
  var label = _ref.label,
    isActive = _ref.isActive,
    tabIndex = _ref.tabIndex,
    _onClick = _ref.onClick,
    allowNavigation = _ref.allowNavigation;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "tab-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return _onClick(tabIndex, allowNavigation);
    },
    role: "button",
    tabIndex: tabIndex,
    onKeyPress: function onKeyPress() {
      return _onClick(tabIndex, allowNavigation);
    },
    className: "\n        tab-element\n        ".concat(isActive ? 'selected' : '', "\n        ").concat(allowNavigation ? 'allowedNavigation' : '', "\n      ")
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "wizzard-step ".concat(isActive ? 'selected' : '')
  }, tabIndex + 1), /*#__PURE__*/_react["default"].createElement("span", null, label)));
};
Tab.propTypes = {
  tabIndex: _propTypes["default"].number,
  isActive: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  label: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].shape({})]).isRequired,
  allowNavigation: _propTypes["default"].bool
};
Tab.defaultProps = {
  tabIndex: 0,
  isActive: false,
  onClick: function onClick() {},
  allowNavigation: false
};
var _default = exports["default"] = Tab;